import { Controller } from "@hotwired/stimulus"
import Stimulus from "../../shared/utils/stimulus"

class LatestNews extends Controller {
  hide(evt) {
    window.Rails.ajax({
      url: evt.target.dataset.latestNewsHideUrl,
      type: `delete`,
      complete: () => {
        evt.target.parentNode.remove()
      },
    })
  }
}

Stimulus.register(`latest-news`, LatestNews)
